export function getAssignmentOrDeliverable(courseId) {
    return courseId === 2 || courseId === 3 ? 'Deliverable' : 'Assignment';
}

export default {
    getAssignmentOrDeliverable,
};
